var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',[_vm._v("How good are you at communicating with sex partners to maintain your BottomLine? Indicate your level of confidence for each of the communication strategies on the next few screens.")])])}
var staticRenderFns = []

export { render, staticRenderFns }